import { createSelector } from '@reduxjs/toolkit';
import { t } from 'src/i18n';
import { singleUserVersion } from '../organization/singleUserVersion';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { LocalDate } from '../../../utilities/local-date';
import { leavePeriodPhrases } from './leave-period-phrases';
import { employeesForStaffingCalendar } from '../staffing/employees-for-staffing-calendar';
import type { ListItemIcon } from '../../../library/lists/listItemIcon';
import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';

export const leavePeriodsToday = createSelector(
  singleUserVersion,
  employeesForStaffingCalendar,
  currentEmployeeUuid,
  (singleUser, employees, currentEmployeeUuid): ListSectionItemInput[] | undefined => {
    if (singleUser) {
      return undefined;
    }
    const today = LocalDate.now();
    const result: ListSectionItemInput[] = [];
    for (const item1 of employees) {
      const periods: {
        confirmed: boolean;
        type: string;
        start: string;
        end: string;
        startTime?: string;
        endTime?: string;
      }[] = item1.leavePeriods;

      for (const item of periods) {
        if (
          item.confirmed &&
          LocalDate.fromString(item.start).isSameOrBefore(today) &&
          LocalDate.fromString(item.end).isSameOrAfter(today)
        ) {
          let employee = item1.displayName;
          if (item1.uuid === currentEmployeeUuid) {
            employee = t('content.revisionChangedByMe');
          }
          let hoursText = '';
          if (item.startTime && item.endTime) {
            hoursText = ' ' + t('staffing.from') + ' ' + item.startTime + ' ' + t('staffing.to') + ' ' + item.endTime;
          }
          const text =
            employee + ' ' + leavePeriodPhrases(item.type) + ' ' + t('dates.today') + hoursText.replace(':', '.');
          result.push({
            mainIcon: item.type as ListItemIcon,
            accessible: false,
            label: text,
          });
        }
      }
    }
    return result;
  },
);
